export enum  UserPermissions {
  CMSAccess = 1 << 0, // 1
  ConnexAccess = 1 << 1, // 2
  PersonalReportAccess= 1 << 2, // 4
  ATEAccess = 1 << 3, // 8
  BlogAccess = 1 << 4 //16
}
